var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0C3.364 0 0 3.365 0 7.5 0 11.636 3.364 15 7.5 15S15 11.636 15 7.5C15 3.365 11.636 0 7.5 0Zm.978 11.413a.978.978 0 1 1-1.956 0V6.522a.978.978 0 1 1 1.956 0v4.891ZM7.5 4.565a.978.978 0 1 1 0-1.956.978.978 0 0 1 0 1.956Z",
  fill: "#000"
})));
export default SvgInfoIcon;